// Persistenza temporanea del form di vendita manuale in sessionStorage.
// Serve a non perdere i dati inseriti quando si esce per creare un cliente/junior
// e si torna indietro. La chiave è il pathname della vendita.

const PREFIX = 'saleDraft:';

export const saveSaleDraft = (key, data) => {
    try {
        sessionStorage.setItem(PREFIX + key, JSON.stringify(data));
    } catch (e) {
        // ignora quota/serializzazione
    }
};

export const loadSaleDraft = (key) => {
    try {
        const raw = sessionStorage.getItem(PREFIX + key);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
};

export const clearSaleDraft = (key) => {
    try {
        sessionStorage.removeItem(PREFIX + key);
    } catch (e) {
        // ignora
    }
};
